








import { Vue, Component } from 'vue-property-decorator'
import { State, Getter } from 'vuex-class'
import { ContentItem } from '../store/content/types'

@Component
export default class LegalsContent extends Vue {
  @State(state => state.CONTENT.iframe) iframe!: boolean

  @Getter('CONTENT/getContents') contents!: ContentItem

  private unwatchConsentLoading!: () => void

  @Getter('CONTENT/areLoaded') areConsentsLoaded!: boolean

  created () {
    /* Will only fire this.load() once and then destroy the watcher */
    this.unwatchConsentLoading = this.$watch('areConsentsLoaded', (areLoaded) => {
      if (areLoaded) {
        const goto = this.$route.query.goto
        if (typeof goto === 'string') {
          const element = document.getElementById(goto)
          if (element !== null) {
            element.scrollIntoView()
          }
        }
        this.unwatchConsentLoading()
      }
    })
  }
}
